import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import WhatIOwnAndWhereItIsKeptStyles from "./Styles";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";

const PdfFooter = ({ primaryColor, regulatoryText }) => {
  const styles = WhatIOwnAndWhereItIsKeptStyles(primaryColor);

  return (
    <View style={styles.footer} fixed>
      {regulatoryText ? (
        <Text
          style={{
            ...styles.FooterTextSmall,
            marginTop: 10,
            width: "100%",
            textAlign: "center",
          }}
        >
          {regulatoryText}
        </Text>
      ) : null}
      <Text
        style={{
          ...styles.FooterTextSmall,
          textAlign: "right",
          width: "100%",
        }}
        render={({ pageNumber }) => `${pageNumber}`}
      />
    </View>
  );
};

export default PdfFooter;
